// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsCloudwatchAlarmsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-cloudwatch-alarms_svga)" d="M40 0H0v40h40z" />
    <svg width={28} height={29} x={6} y={5.5} viewBox="0 0 28 29">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M25.12 24.64H20.8V11.36a7 7 0 0 0 4.32 0zm.37-14.79a5.9 5.9 0 0 1-5.06 0 .64.64 0 0 0-.9.58v14.85c0 .35.28.63.63.63h5.6c.35 0 .64-.28.64-.63V10.43a.64.64 0 0 0-.91-.58m-2.53-8.58a3.29 3.29 0 1 1 0 6.58 3.29 3.29 0 0 1 0-6.58m0 7.84A4.56 4.56 0 1 0 22.95 0a4.56 4.56 0 0 0 0 9.12M0 28.15h28v-1.27H0zm11.84-3.51h4.32v-8.25h-4.32zm-.64 1.27h5.6c.35 0 .64-.28.64-.63v-9.52a.64.64 0 0 0-.64-.64h-5.6a.64.64 0 0 0-.64.64v9.52c0 .35.29.63.64.63m-8.32-1.27H7.2V13.59H2.88zm-.64 1.27h5.6c.35 0 .64-.28.64-.63V12.96a.64.64 0 0 0-.64-.64h-5.6a.64.64 0 0 0-.64.64v12.32c0 .35.29.63.64.63"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-cloudwatch-alarms_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsCloudwatchAlarms",
);
export default AwsCloudwatchAlarmsIcon;
